/* eslint-disable no-empty-pattern */
import {call, put} from 'redux-saga/effects'
import {push} from 'connected-react-router'
import AuthActions from '../Redux/AuthRedux'
import ErrorsActions from '../Redux/ErrorsRedux'
import SuggestHelpActions from '../Redux/SuggestHelpRedux'
import ReportAdminActions from '../Redux/ReportAdminRedux'
import SuggestHelpAdminActions from '../Redux/SuggestHelpAdminRedux'

export function* getPages(api, authApi, {}) {
  try {
    const response = yield call(api.getPages)
    if (response && response.ok) {
      yield put(SuggestHelpActions.getPagesSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(SuggestHelpActions.getPagesFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* getPages(api, authApi, {})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(SuggestHelpActions.getPagesFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* sendSuggest(api, authApi, {data}) {
  try {
    const response = yield call(api.sendSuggest, data)
    if (response && response.ok) {
      yield put(SuggestHelpActions.sendSuggestSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else if (response.status === 413) {
          yield put(ErrorsActions.errorSave('Sorry, server response error. The files being sent are too large'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(SuggestHelpActions.sendSuggestReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* sendSuggest(api, authApi, {data})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(SuggestHelpActions.sendSuggestReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* sendHelp(api, authApi, {data}) {
  try {
    const response = yield call(api.sendHelp, data)
    if (response && response.ok) {
      yield put(SuggestHelpActions.sendHelpSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else if (response.status === 413) {
          yield put(ErrorsActions.errorSave('Sorry, server response error. The files being sent are too large'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(SuggestHelpActions.sendHelpReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* sendHelp(api, authApi, {data})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(SuggestHelpActions.sendHelpReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* getTickets(api, authApi, {page, page_size, sort, nextPage, search}) {
  try {
    const response = yield call(api.getTickets, page, page_size, sort, nextPage, search)
    if (response && response.ok) {
      yield put(SuggestHelpAdminActions.getTicketsSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(SuggestHelpAdminActions.getTicketsFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* getTickets(api, authApi, {page, page_size, sort, nextPage, search})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(SuggestHelpAdminActions.getTicketsFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* getReports(api, authApi, {page, page_size, sort, nextPage, search}) {
  try {
    const response = yield call(api.getReports, page, page_size, sort, nextPage, search)
    if (response && response.ok) {
      yield put(ReportAdminActions.getReportsSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(ReportAdminActions.getReportsFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* getReports(api, authApi, {page, page_size, sort, nextPage, search})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(ReportAdminActions.getReportsFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* getTicketId(api, authApi, {id}) {
  try {
    const response = yield call(api.getTicketId, id)
    if (response && response.ok) {
      yield put(SuggestHelpAdminActions.getTicketIdSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(SuggestHelpAdminActions.getTicketsFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* getTicketId(api, authApi, {id})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(SuggestHelpAdminActions.getTicketsFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* getReportId(api, authApi, {id}) {
  try {
    const response = yield call(api.getReportId, id)
    if (response && response.ok) {
      yield put(ReportAdminActions.getReportIdSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(ReportAdminActions.getReportsFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* getReportId(api, authApi, {id})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(ReportAdminActions.getReportsFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* deleteTicket(api, authApi, {id}) {
  try {
    const response = yield call(api.deleteTicket, id)
    if (response && response.ok) {
      yield put(SuggestHelpAdminActions.deleteTicketSuccess(id))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(SuggestHelpAdminActions.getTicketsFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* deleteTicket(api, authApi, {id})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(SuggestHelpAdminActions.getTicketsFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* deleteReport(api, authApi, {id}) {
  try {
    const response = yield call(api.deleteReport, id)
    if (response && response.ok) {
      yield put(ReportAdminActions.deleteReportSuccess(id))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(ReportAdminActions.getReportsFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* deleteReport(api, authApi, {id})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(ReportAdminActions.getReportsFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}
